import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderCreativesTable } from '~/components/recruiting/creatives-table';
import { html, LpButton, LpFilterBar, LpFilterCell, LpPageHeader, LpSearchInput, raw } from '~/design-system';
import { getEntityActiveStatusOption } from '~/utils/entityActiveStatus';
export class adminCreatives_template extends vnTemplate {
    getTemplateName() {
        return 'adminCreatives-template';
    }
    getMainElementClasses() {
        return ['w-content'];
    }
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.statusFilter = new listPageSelect_template('adminCreativesStatusFilter', vm, this.caller);
        this.statusFilter.setLabel('Status');
        this.statusFilter.setShowLabelPrefix(true);
        this.statusFilter.setIcon('info');
        this.statusFilter.setOptions([
            { id: '', name: 'All statuses' },
            getEntityActiveStatusOption({ id: '1', name: 'Active' }),
            getEntityActiveStatusOption({ id: '0', name: 'Inactive' }),
            getEntityActiveStatusOption({ id: '2', name: 'Archived' }),
        ]);
        this.statusFilter.bindValue(vm.status);
    }
    buildViewModel() {
        const self = this;
        return {
            creatives: ko.observableArray([]),
            title: ko.observable(''),
            partnerId: ko.observable(''),
            status: ko.observable(''),
            onClickCreate: function () { self.caller.createCreative(); },
            onClickEdit: function (row) { self.caller.editCreative(row.id); },
            onClickDuplicate: function (row) { self.caller.duplicateCreative(row.id); },
            onFilterChange: function () { self.caller.getListData(); },
        };
    }
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: 'Creatives',
            description: 'Manage partner creative assets and copy.',
            icon: 'image',
            controls: LpFilterBar({
                className: 'creatives-control-bar',
                controls: html `
                        ${LpFilterCell({
                    search: true,
                    children: LpSearchInput({
                        placeholder: 'Creative title',
                        attributes: {
                            'data-bind': 'value: title, event: { change: onFilterChange }',
                        },
                    }),
                })}

                        ${LpFilterCell({
                    search: true,
                    narrow: true,
                    children: LpSearchInput({
                        type: 'number',
                        placeholder: 'Partner ID',
                        attributes: {
                            'data-bind': 'value: partnerId, event: { change: onFilterChange }',
                        },
                    }),
                })}

                        ${LpFilterCell({
                    children: raw(this.statusFilter.getHtmlBuild()),
                })}
                    `,
                actions: LpButton({
                    label: 'Create New Creative',
                    prefixIcon: 'plus',
                    size: 'base',
                    variant: 'primary',
                    attributes: {
                        'data-bind': 'click: onClickCreate',
                    },
                }),
            }),
        })}

            <div class="list-page-module creatives-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderCreativesTable()}
                </div>
            </div>
        `;
    }
    getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        return {
            title: vm.title(),
            partnerId: vm.partnerId(),
            status: vm.status(),
            size: 100,
            page: 0,
        };
    }
    setCreatives(rows) {
        this.getTemplateViewModel().creatives((rows || []).map((row) => {
            const creativeId = row.id || row.creative_id || row.creativeId;
            return {
                ...row,
                id: creativeId,
                descShortLabel: String(row.descShort || '')
                    .replace(/<br\s*\/?>/gi, ' ')
                    .replace(/\s+/g, ' ')
                    .trim(),
                statusValue: Number(row.status || row.creativeStatus || 0),
                statusLabel: Number(row.status || row.creativeStatus || 0) === 1
                    ? 'Active'
                    : (Number(row.status || row.creativeStatus || 0) === 2 ? 'Archived' : 'Inactive'),
                smallIconUrl: row.imageSmall ? 'data:image/png;base64,' + row.imageSmall : '',
            };
        }));
    }
}
